// Desktop modal functionality only
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }
      
      isMobile() {
        return window.innerWidth <= 989;
      }
      
      show(opener) {
        // Only use on desktop
        if (this.isMobile()) {
          console.log('Mobile detected - using PhotoSwipe');
          return;
        }
        
        console.log('Desktop - using custom modal');
        super.show(opener);
        this.showActiveMedia();
      }
      
      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (activeMedia) {
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();
          
          const container = this.querySelector('[role="document"]');
          if (container && activeMedia.width) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }
        }
      }
    }
  );
}